import { ClipboardIcon } from '@heroicons/react/24/outline';
import React from 'react';
import Button from '@dashboard/components/Button';
import CopyTextWithTooltip from '@dashboard/components/CopyTextWithTooltip';

import { Form } from '@dashboard/components/Formik';

import useProduct from '../useProduct';

const ProductLicenseKeysForm = () => {
  const { product, updateProduct } = useProduct();

  return (
    <div>
      <Form
        autosave
        showState={false}
        initialValues={{
          generateLicenseKeys: product?.generateLicenseKeys,
        }}
        onSubmit={async values => {
          const { data, error } = await updateProduct.mutateAsync(values);

          return {
            data,
            error,
          };
        }}
        fields={({ values }) => [
          {
            name: 'generateLicenseKeys',
            label: 'Generate license keys for each purchase',
            type: 'toggle',
          },
          ...(values.generateLicenseKeys
            ? [
                {
                  type: 'custom',
                  label: 'Product ID',
                  labelDescription: 'Use the Product ID to verify purchases in your application',
                  renderField: () => (
                    <div className="mb-1 flex">
                      <div className="appearance-none inline-flex py-1 px-2 text-gray-800 rounded-md border-none shadow-input focus:shadow-input-focus bg-gray-50">
                        {product._id}
                      </div>
                      <div>
                        <CopyTextWithTooltip text={product._id}>
                          <Button appearance="light" className="ml-1.5">
                            <ClipboardIcon className="w-4 h-4" />
                          </Button>
                        </CopyTextWithTooltip>
                      </div>
                    </div>
                  ),
                },
              ]
            : []),
        ]}
      />
    </div>
  );
};

export default ProductLicenseKeysForm;
